import Vue from 'vue'

Vue.component('domain-status', {
    template: `
    <span class="badge" :class="{
        'bg-green':v === 'ready',
        'bg-orange':v === 'waiting for confirmation',
        'bg-danger':v === 'new'
    }">{{v}}</span>`,
    props: {
        value: null
    },
    computed: {
        v() {

            if (this.value.subdomains_status) {
                switch (this.value.subdomains_status) {
                    case "new":
                        return "new"
                    case "pending":
                        return "waiting for confirmation"
                    case "confirmed":
                        return "ready"
                }
            }

            if (this.value.all_subdomains_validated) {
                return 'ready'
            }

            if (this.value.all_subdomains_ready) {
                return 'waiting for confirmation'
            }

            return 'new'
        }
    }
})

Vue.component('worker-status', {
    template: `
    <span class="badge" :class="{
        'bg-grey': status == 'offline', 
        'badge-success': status == 'processing', 
        'badge-primary': status == 'idle'}">{{status}}</span>
    `,
    props: {
        worker: null
    },
    computed: {
        status() {
            var diff = (new Date).getTime() - (new Date(this.worker.last_active_at)).getTime()
            if (diff > 10000) {
                return 'offline'
            }

            if (diff <= 10000 && this.worker.current_per_sec > 0) {
                return 'processing'
            }

            return 'idle'
        }
    }
})




// WEBPACK FOOTER //
// ./src/commons.js